import { Utilities } from '@spectorasoftware/homegauge-shared';
import Api from '@/api';

const { LogRocketUtility } = Utilities;

const addLogRocketIdentity = user => {
  if (!user) {
    return;
  }

  const { legacyId, primaryEmail, username } = user;
  try {
    LogRocketUtility.addUser(legacyId, { email: primaryEmail, name: username });
  } catch (err) {
    // eat the error
  }
};

const getPerson = context => new Promise((resolve, reject) => {
  Api.personService.getMyPerson()
    .then(response => {
      if (response.data) {
        if (response.data.type === 'INSPECTOR') {
          document.location = `${process.env.VUE_APP_HG_CLASSIC_URL}/inspector/shgi/appointment/schedule.htmls`;
        }

        context.commit('setPerson', response.data);
        addLogRocketIdentity(response.data);
      }
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setPerson', null);
      reject(error);
    });
});

const loginUser = (context, user) => new Promise((resolve, reject) => {
  Api.authService.authorize(user.username, user.password)
    .then(response => {
      context.commit('setUser', response.data);
      Api.authService.setAuthToken(response.data.access_token);
      resolve(response.data);
    })
    .catch(error => {
      reject(error.data);
    });
});

const resetUser = context => {
  context.commit('setPerson', null);
  context.commit('setUser', null);
};

export default {
  getPerson,
  loginUser,
  resetUser,
};
